module.exports = __webpack_public_path__ + "img/fintech.6920318f.png";